import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import '../stylings/TopHeader.css';

export default function TopHeader() {
  return (
    <div className="top-header">
      <div className="container-fluid px-4">
        <div className="row align-items-center">
          <div className="col-lg-8 col-md-7 d-none d-md-flex top-header-left gap-4">
            <a href="tel:9999355051" className="top-header-link">
              <FaPhone className="top-header-icon" />
              <span>9999355051</span>
            </a>
            <a href="tel:9211101997" className="top-header-link">
              <FaPhone className="top-header-icon" />
              <span>9211101997</span>
            </a>
            <a href="mailto:akashmodelschool5051@gmail.com" className="top-header-link">
              <FaEnvelope className="top-header-icon" />
              <span>akashmodelschool5051@gmail.com</span>
            </a>
            <span className="top-header-link">
              <FaMapMarkerAlt className="top-header-icon" />
              <span>Baljeet Vihar, Near Rohini Sec-22, New Delhi-110086</span>
            </span>
          </div>
          <div className="col-lg-4 col-md-5 d-flex justify-content-end top-header-right gap-3">
            <a href="https://www.facebook.com/akashmodelseniorsecondaryschool" target="_blank" rel="noreferrer" className="top-social-link"><FaFacebook /></a>
            <a href="https://www.youtube.com/@akashmodelschool2063" target="_blank" rel="noreferrer" className="top-social-link"><FaYoutube /></a>
            <a href="https://instagram.com/akash_model_sr._sec._school?igshid=NTdlMDg3MTY=" target="_blank" rel="noreferrer" className="top-social-link"><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
  );
}
